function renderSections(parsedState) {
  getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
    sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
  });

  function getSectionInnerHTML(html, selector) {
    console.log('getSectionInnerHTML', selector)
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

}

function getSectionsToRender() {
  console.log('getSectionsToRender')
  return [
    {
      id: 'cart-drawer-dialog',
      selector: '#cart-drawer-dialog',
    },
    {
      id: 'cart-icon-bubble',
      selector: '#cart-icon-bubble',
    },

  //return [
    //{
      //id: 'cart-drawer',
      //selector: '#CartDrawer',
    //},
    //{
      //id: 'cart-icon-bubble',
    //},
  //];

    //{
      //id: 'CartDrawer',
      //section: 'cart-drawer',
      //selector: '.drawer__container',
    //},
    //{
      //id: 'cart-icon-bubble',
      //section: 'cart-icon-bubble',
      //selector: '.shopify-section',
    //},

  ];
}

  //getSectionsToRender() {
    //console.log('getSectionsToRender')
    //return [
      //{
        //id: 'cart-drawer',
        //selector: '#CartDrawer',
      //},
      //{
        //id: 'cart-icon-bubble',
      //},
    //];
  //}